export const accessories = {
	label: {
		accessory: 'Add Accessory',
		hideAccessory: 'Hide Accessory',
		add: 'Add',
		delete: 'Delete'
	},
	tooltip: {
		addAccessory: 'Click to add accessory',
		hideAccessory: 'Click to hide accessory',
		addSku: 'Add SKU',
		selectSku: 'Select Accessory',
		deleteSku: 'Delete SKU'
	},
	message: {
	}
};
